<template>
  <div>
    <div class="row mb-2 pe-4">
      <div class="col-lg-12 col-md-12 col-12 d-flex align-items-center">
        <div class="color-common">
          <h3 class="title-page mb-0 ps-3">CRM REPORTS</h3>
        </div>
      </div>
    </div>
    <div class="page-header align-items-start min-vh-100 my-transacions">
      <span class="mask bg-white"></span>
      <div class="container">
        <div class="row">
          <div class="col-lg-12 col-md-12 col-12 mx-auto mt-4">
            <div class="row">
              <strong> Member Voucher Report </strong>
            </div>
            <div class="mv-filter mt-3">
              <div class="row g-3">
                <div class="col-xl-3 col-md-6 col-12">
                  <label class="mv-label">Received</label>
                  <Multiselect
                    v-model="time_type"
                    :options="times"
                    :canClear="false"
                    @change="timeChange($event)"
                  />
                </div>
                <template v-if="isShowTimeCustom">
                  <div class="col-xl-3 col-md-6 col-12">
                    <label class="mv-label">From</label>
                    <Datepicker
                      :enableTimePicker="false"
                      v-model="from_date"
                      :format="format"
                      :maxDate="to_date || undefined"
                      autoApply
                    />
                  </div>
                  <div class="col-xl-3 col-md-6 col-12">
                    <label class="mv-label">To</label>
                    <Datepicker
                      :enableTimePicker="false"
                      v-model="to_date"
                      :format="format"
                      :minDate="from_date || undefined"
                      autoApply
                    />
                  </div>
                </template>
                <div class="col-xl-3 col-md-6 col-12">
                  <label class="mv-label">Type</label>
                  <Multiselect
                    v-model="row_type"
                    :options="rowTypes"
                    :canClear="false"
                  />
                </div>
                <div class="col-xl-3 col-md-6 col-12">
                  <label class="mv-label">Status</label>
                  <Multiselect
                    v-model="status"
                    :options="statuses"
                    mode="multiple"
                    :close-on-select="false"
                    :multiple-label="selectedLabel"
                    placeholder="All statuses"
                  />
                </div>
                <div class="col-xl-3 col-md-6 col-12">
                  <label class="mv-label">Source</label>
                  <Multiselect
                    v-model="source"
                    :options="sources"
                    mode="multiple"
                    :close-on-select="false"
                    :multiple-label="selectedLabel"
                    :searchable="true"
                    placeholder="All sources"
                  />
                </div>
                <div class="col-xl-6 col-12">
                  <label class="mv-label">Search</label>
                  <input
                    class="nosubmit"
                    type="search"
                    id="keyword_search"
                    v-model="searchKeyword"
                    name="keyword_search"
                    placeholder="Member ID, name, phone, email, voucher / bundle name or voucher code"
                    @keydown.enter="filterData()"
                  />
                </div>
              </div>
              <div class="d-flex flex-wrap align-items-center gap-2 mt-4">
                <material-button
                  class="btn-background btn-sm mv-run"
                  @click="filterData()"
                >
                  Run
                </material-button>
                <button
                  type="button"
                  class="btn btn-link btn-sm mb-0 text-secondary"
                  @click="resetFilters()"
                >
                  Reset filters
                </button>
                <div class="dropdown ms-auto">
                  <button
                    class="btn btn-secondary dropdown-toggle btn-sm mb-0"
                    type="button"
                    id="dropdownMenuButton1"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    aria-haspopup="true"
                  >
                    Download
                  </button>
                  <ul
                    class="dropdown-menu dropdown-menu-end"
                    aria-labelledby="dropdownMenuButton1"
                  >
                    <li>
                      <a class="dropdown-item" @click="exportFile('csv')" href="#">
                        Export CSV
                      </a>
                    </li>
                    <li>
                      <a class="dropdown-item" @click="exportFile('xlsx')" href="#">
                        Export Excel
                      </a>
                    </li>
                    <li>
                      <a class="dropdown-item" @click="exportFile('pdf')" href="#">
                        Export PDF
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="row mt-1 ps-3">
              <div
                class="col-lg-9 col-md-12 col-12 d-flex justify-content-lg-start align-items-end"
              >
                Count: {{ totalRecords }}
              </div>
              <div class="col-lg-3 col-md-3 col-3 d-flex justify-content-end">
                <ShowHideColumn
                  :columns="columns"
                  :changeCheckbox="changeCheckbox"
                  :columnCheckedCache="columnChecked"
                  :key="key"
                />
              </div>
            </div>
            <div class="row mt-4" style="min-height: 1120px">
              <div class="col-12">
                <div class="card-custom">
                  <div class="px-0 pb-2">
                    <div class="table-responsive p-0 custom-table">
                      <table class="table align-items-center mb-0">
                        <thead>
                          <tr>
                            <th
                              class="text-center font-weight-bolder"
                              v-if="columnShowed.includes('row_no')"
                            >
                              Row No
                            </th>
                            <template
                              v-for="(item, index) in headersData"
                              :key="index"
                            >
                              <th
                                class="text-center font-weight-bolder"
                                v-if="columnShowed.includes(item.field)"
                              >
                                <span
                                  :class="[
                                    item.sortBy ? 'wrapper-sortby pointer' : '',
                                    sortBy && sortBy === item.sortBy
                                      ? sortType === 'desc'
                                        ? 'sort-desc'
                                        : 'sort-asc'
                                      : '',
                                  ]"
                                  @click="item.sortBy && handleChangeSortColumn(item.sortBy)"
                                  >{{ item.label }}</span
                                >
                              </th>
                            </template>
                            <th class="text-center font-weight-bolder">
                              Action
                            </th>
                          </tr>
                        </thead>
                        <tbody v-if="reportData.length">
                          <tr v-for="(value, key) in reportData" :key="key">
                            <td
                              class="text-center text-xss w-5"
                              v-if="columnShowed.includes('row_no')"
                            >
                              {{ rowOffset + key + 1 }}
                            </td>
                            <template
                              v-for="(item, index) in headersData"
                              :key="index"
                            >
                              <td
                                class="text-center text-xss"
                                v-if="columnShowed.includes(item.field)"
                              >
                                <span
                                  v-if="item.field === 'status_text'"
                                  :class="statusClass(value.status)"
                                  >{{ value.status_text }}</span
                                >
                                <template v-else>{{ value[item.field] }}</template>
                              </td>
                            </template>
                            <td class="text-center text-xss">
                              <material-button
                                v-if="value.row_type === 'bundle'"
                                class="btn-background btn-sm"
                                @click="showBundleVouchers(value)"
                              >
                                View Vouchers
                              </material-button>
                            </td>
                          </tr>
                        </tbody>
                        <tbody v-else>
                          <tr>
                            <td colspan="20" class="text-center">
                              No item available
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <pagination
                    v-if="pagination.last_page > 1"
                    :pagination="pagination"
                    :current_page="pagination.current_page"
                    :last_page="pagination.last_page"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="position-fixed top-1 end-1 z-index-2 message-success">
        <material-snackbar
          v-if="snackbar === 'danger' || snackbar === 'success'"
          title=""
          date=""
          :description="message"
          :icon="{ component: 'campaign', color: 'white' }"
          :color="snackbar"
          :close-handler="closeSnackbar"
        />
      </div>
      <material-loading :active="loaderActive" />
    </div>

    <button
      style="display: none"
      type="button"
      class="show-modal-member-bundle-vouchers"
      data-bs-toggle="modal"
      data-bs-target="#modalMemberBundleVouchers"
    ></button>
    <div
      class="modal fade"
      id="modalMemberBundleVouchers"
      tabindex="-1"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-xl">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              {{ bundleSelected.item_title }} — {{ bundleSelected.member_id_format }}
              {{ bundleSelected.member_name }}
            </h5>
            <i
              style="cursor: pointer"
              class="material-icons btn-close-modal justify-content-end"
              data-bs-dismiss="modal"
              >clear</i
            >
          </div>
          <div class="modal-body">
            <div class="mb-2 text-sm">
              Received: {{ bundleSelected.received_at_format }} · Expiry:
              {{ bundleSelected.expired_date_format }} · Status:
              {{ bundleSelected.status_text }} ({{ bundleSelected.usage_text }})
            </div>
            <div class="table-responsive p-0 custom-table">
              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th class="text-center font-weight-bolder">Row No</th>
                    <th class="text-center font-weight-bolder">Voucher</th>
                    <th class="text-center font-weight-bolder">Voucher Code</th>
                    <th class="text-center font-weight-bolder">Expiry Date</th>
                    <th class="text-center font-weight-bolder">Status</th>
                    <th class="text-center font-weight-bolder">Used Date</th>
                    <th class="text-center font-weight-bolder">Used At Branch</th>
                  </tr>
                </thead>
                <tbody v-if="bundleVouchers.length">
                  <tr v-for="(value, key) in bundleVouchers" :key="key">
                    <td class="text-center text-xss">{{ key + 1 }}</td>
                    <td class="text-center text-xss">{{ value.item_title }}</td>
                    <td class="text-center text-xss">{{ value.code }}</td>
                    <td class="text-center text-xss">{{ value.expired_date_format }}</td>
                    <td class="text-center text-xss">
                      <span :class="statusClass(value.status)">{{
                        value.status_text
                      }}</span>
                    </td>
                    <td class="text-center text-xss">{{ value.used_at_format }}</td>
                    <td class="text-center text-xss">{{ value.used_branch }}</td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td colspan="7" class="text-center">No item available</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <form
      :action="`${actionDownload}/merchant/download-member-voucher-report`"
      method="POST"
    >
      <input type="hidden" name="merchantId" :value="merchantIdExport" />
      <input type="hidden" name="merchant_code" :value="merchantCode" />
      <input type="hidden" name="token" :value="token" />
      <input type="hidden" name="list_field_show" :value="columnShowed" />
      <input type="hidden" name="search_keyword" :value="searchKeyword" />
      <input type="hidden" name="time_type" :value="time_type" />
      <input type="hidden" name="from_date" :value="dateFormat(from_date)" />
      <input type="hidden" name="to_date" :value="dateFormat(to_date)" />
      <input type="hidden" name="row_type" :value="row_type" />
      <input type="hidden" name="source" :value="source" />
      <input type="hidden" name="status" :value="status" />
      <input type="hidden" name="sort_by" :value="sortBy" />
      <input type="hidden" name="sort_type" :value="sortType" />
      <input type="hidden" name="action_export" :value="action_export" />
      <input type="hidden" name="action" value="export" />
      <input id="downloadForm" type="submit" class="d-none" />
    </form>
  </div>
</template>

<script>
import MaterialSnackbar from "@/components/MaterialSnackbar.vue";
import "bootstrap/dist/js/bootstrap.bundle";
import MaterialLoading from "@/components/MaterialLoading.vue";
import Pagination from "@/components/Pagination.vue";
import "bootstrap/js/dist/modal";
import Multiselect from "@vueform/multiselect";
import "@vueform/multiselect/themes/default.css";
import MaterialButton from "@/components/MaterialButton.vue";
import ShowHideColumn from "@/components/ShowHideColumn.vue";
import Datepicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import moment from "moment";
import DashboardReportService from "../../services/dashboardReport.service";
import $ from "jquery";
import TokenService from "../../services/token.service";
import CommonFunctionService from "../../services/commonFunction.service";

const COLUMN_CACHE_KEY = "MemberVoucherReportColumn";
// keep in sync with MemberVoucherReportPdf::MAX_LINES (BE still guards: bundle vouchers add lines)
const PDF_MAX_ROWS = 2000;

export default {
  name: "member-voucher-report",
  components: {
    MaterialSnackbar,
    MaterialLoading,
    MaterialButton,
    Pagination,
    Multiselect,
    Datepicker,
    ShowHideColumn,
  },
  data() {
    return {
      token: TokenService.getLocalAccessToken(),
      actionDownload: process.env.VUE_APP_BASE_URL,
      merchantIdExport: localStorage.getItem("MERCHANT_ID", ""),
      merchantCode: localStorage.getItem("MERCHANT_CODE", ""),
      message: "",
      snackbar: null,
      loaderActive: false,
      searchKeyword: "",
      pagination: {},
      page: 1,
      key: 0,
      // default to a bounded range: the report UNIONs every voucher in range before paging
      time_type: 4,
      times: [
        { value: 0, label: "All Time" },
        { value: 1, label: "Today" },
        { value: 2, label: "Yesterday" },
        { value: 3, label: "Last 7 days" },
        { value: 4, label: "Last 30 days" },
        { value: 5, label: "This month" },
        { value: 6, label: "Last 3 months" },
        { value: 7, label: "This year" },
        { value: 8, label: "Last year" },
        { value: 9, label: "Custom" },
      ],
      from_date: null,
      to_date: null,
      isShowTimeCustom: false,
      row_type: "",
      rowTypes: [
        { value: "", label: "All" },
        { value: "voucher", label: "Voucher" },
        { value: "bundle", label: "Voucher Bundle" },
      ],
      status: [],
      statuses: [
        { value: "available", label: "Available" },
        { value: "used", label: "Used" },
        { value: "locked", label: "Locked" },
        { value: "expired", label: "Expired" },
      ],
      source: [],
      sources: [
        { value: "exchange", label: "Exchanged (points / cashback / card)" },
        { value: "voucher_bundle", label: "Voucher Bundle exchange" },
        { value: "invite_friend", label: "Invite Friend" },
        { value: "update_profile", label: "Update Profile" },
        { value: "welcome_tier", label: "Welcome Tier" },
        { value: "birthday_tier", label: "Birthday Tier" },
        { value: "campaign", label: "Campaign" },
        // no "paid_membership": nothing issues that voucher type today, the option would always be empty
        { value: "manual_issue", label: "Issued by Merchant" },
        { value: "bulk_issue_code", label: "Bulk Voucher Issuance" },
        { value: "bulk_action", label: "Bulk Action" },
      ],
      action_export: "csv",
      totalRecords: 0,
      columnShowed: [],
      columnChecked: [],
      reportData: [],
      sortBy: "",
      sortType: "",
      bundleSelected: {},
      bundleVouchers: [],
    };
  },
  created() {
    if (this.$route.query.page) {
      this.page = this.$route.query.page;
    }
    const cached = window.localStorage.getItem(COLUMN_CACHE_KEY);
    if (cached) {
      this.columnChecked = cached.split(",");
      this.key = Math.random();
    }
    // bounded (last 30 days) and indexed: show data on open instead of an empty table
    this.getList(Number(this.page) || 1);
  },
  computed: {
    rowOffset() {
      const p = this.pagination;
      return p.current_page > 1 ? (p.current_page - 1) * (p.per_page || 0) : 0;
    },
    headersData() {
      return [
        { label: "Type", field: "row_type_text", sortBy: "row_type" },
        { label: "Voucher / Bundle", field: "item_title", sortBy: "item_title" },
        { label: "Voucher Code", field: "code" },
        { label: "Member ID", field: "member_id_format", sortBy: "member_id" },
        { label: "Member Name", field: "member_name" },
        { label: "Phone No", field: "phone_number" },
        { label: "Source", field: "source_text", sortBy: "source" },
        { label: "Reason", field: "reason" },
        { label: "Received Date", field: "received_at_format", sortBy: "received_at" },
        { label: "Expiry Date", field: "expired_date_format", sortBy: "expired_date" },
        { label: "Status", field: "status_text", sortBy: "status" },
        { label: "Bundle Usage", field: "usage_text" },
        { label: "Used Date", field: "used_at_format" },
        { label: "Used At Branch", field: "used_branch" },
      ];
    },
    columns() {
      return [
        { value: "all", label: "All" },
        { value: "row_no", label: "Row No" },
        ...this.headersData.map((h) => ({ value: h.field, label: h.label })),
      ];
    },
  },
  methods: {
    format(date) {
      return CommonFunctionService.formatDateShow(date);
    },

    // own classes: the merchant theme recolours Bootstrap's bg-* (everything came out red)
    statusClass(status) {
      return "mv-status mv-status--" + (status || "unknown");
    },

    selectedLabel(values) {
      return values.length === 1 ? values[0].label : `${values.length} selected`;
    },

    resetFilters() {
      this.time_type = 4;
      this.isShowTimeCustom = false;
      this.from_date = null;
      this.to_date = null;
      this.row_type = "";
      this.status = [];
      this.source = [];
      this.searchKeyword = "";
    },

    exportFile(type = "csv") {
      if (this.columnShowed.length == 0) {
        this.snackbar = "danger";
        this.message = "You must select least 1 column to export file.";
        this.setTimeOutNotification();
        return;
      }
      if (type !== "pdf") {
        this.submitExport(type);
        return;
      }
      // PDF is slow on long tables: count rows for the current filters first
      this.loaderActive = true;
      DashboardReportService.getDataMemberVoucherReport(this.buildDataForm(1)).then(
        (response) => {
          this.loaderActive = false;
          const total = response.data.result.isSuccess ? response.data.data.total : 0;
          if (total > PDF_MAX_ROWS) {
            this.snackbar = "danger";
            this.message = `${total} rows — PDF export is limited to ${PDF_MAX_ROWS}. Use Export Excel or narrow the filters.`;
            this.setTimeOutNotification();
          } else {
            this.submitExport(type);
          }
        },
        () => {
          this.loaderActive = false;
          this.submitExport(type);
        }
      );
    },

    submitExport(type) {
      this.action_export = type;
      setTimeout(() => {
        $("#downloadForm").click();
      }, 150);
    },

    changeCheckbox(columnShowed) {
      this.columnShowed = columnShowed;
      window.localStorage.setItem(COLUMN_CACHE_KEY, columnShowed);
    },

    timeChange($event) {
      this.isShowTimeCustom = $event == 9;
    },

    filterData() {
      this.getList(1);
    },

    dateFormat(date) {
      return date == null ? null : moment(date).format("YYYY-MM-DD");
    },

    closeSnackbar() {
      this.snackbar = null;
    },

    setTimeOutNotification() {
      setTimeout(() => {
        this.snackbar = null;
      }, 3000);
    },

    handleChangeSortColumn(sortBy) {
      if (this.sortBy === sortBy) {
        this.sortType = this.sortType === "asc" ? "desc" : "asc";
      } else {
        this.sortBy = sortBy;
        this.sortType = "asc";
      }
      if (this.reportData.length) {
        this.getList(this.page);
      }
    },

    buildDataForm(page) {
      return {
        action: "list",
        search_keyword: this.searchKeyword,
        time_type: this.time_type,
        from_date: this.dateFormat(this.from_date),
        to_date: this.dateFormat(this.to_date),
        row_type: this.row_type,
        source: this.source,
        status: this.status,
        sort_by: this.sortBy,
        sort_type: this.sortType,
        page: page,
      };
    },

    getList(page) {
      this.totalRecords = 0;
      this.loaderActive = true;
      DashboardReportService.getDataMemberVoucherReport(this.buildDataForm(page)).then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.reportData = response.data.data.items;
            this.pagination = response.data.data;
            this.page = this.pagination.current_page;
            this.totalRecords = this.pagination.total;
            if (this.pagination.current_page > this.pagination.last_page) {
              this.getList(1);
            }
            this.$router.push({
              query: Object.assign({}, this.$route.query, { page: this.page }),
            });
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
          this.loaderActive = false;
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error;
          this.loaderActive = false;
          this.setTimeOutNotification();
        }
      );
    },

    showBundleVouchers(row) {
      this.bundleSelected = row;
      this.bundleVouchers = [];
      this.loaderActive = true;
      DashboardReportService.getMemberVoucherBundleDetail(row.record_id).then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.bundleVouchers = response.data.data;
            $(".show-modal-member-bundle-vouchers").click();
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
          this.loaderActive = false;
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error;
          this.loaderActive = false;
          this.setTimeOutNotification();
        }
      );
    },
  },
};
</script>
<style scoped>
table thead th:not(:first-child) {
  min-width: 150px;
}

table thead th > span {
  position: relative;
}

input[type="search"] {
  border: none;
  background: transparent;
  margin: 0;
  padding: 7px 8px;
  font-size: 14px;
  color: inherit;
  border: 1px solid transparent;
  border-radius: inherit;
}

input[type="search"]::placeholder {
  color: #bbb;
  text-align: left;
  font-weight: normal;
}

input[type="search"]:focus {
  border-color: #72959d;
  outline: none;
  border: none;
  border-bottom: 2px solid #72959d;
}

.mv-filter {
  padding: 16px;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  background: #fff;
}

.mv-label {
  display: block;
  margin: 0 0 4px;
  font-size: 0.8rem;
  font-weight: 600;
  color: #6c757d;
}

.mv-run {
  min-width: 140px;
}

.mv-status {
  display: inline-block !important;
  padding: 3px 10px;
  border-radius: 999px;
  font-size: 0.7rem;
  font-weight: 600;
  text-transform: none;
}

.mv-status--available { background: #e6f4ea; color: #1e7b34; }
.mv-status--used { background: #eceef1; color: #495057; }
.mv-status--locked { background: #fff4e0; color: #9a5b00; }
.mv-status--expired { background: #fdecea; color: #b42318; }
.mv-status--unknown { background: #f1f1f1; color: #495057; }

input.nosubmit {
  border-bottom: 1px solid #d2d2d2;
  width: 100%;
  padding: 9px 4px 9px 40px;
  background: transparent
    url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' class='bi bi-search' viewBox='0 0 16 16'%3E%3Cpath d='M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z'%3E%3C/path%3E%3C/svg%3E")
    no-repeat 13px center;
}

</style>
